import { Button } from 'app/components/common/Button';
import { CheckboxControl } from 'app/components/common/CheckboxControl';
import { InputControl } from 'app/components/common/InputControl';
import { Modal } from 'app/components/Modal';
import { useStore } from 'app/context';
import { UserStatus } from 'app/models/core/user.model';
import { BnrMulitDiffVM } from 'app/stores/ui/admin.bnr.diff.ui.store';
import { UserVM } from 'app/stores/ui/admin.user.ui.store';
import { formatDateLong } from 'app/utils';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import routes from 'routes';
import Panel from '../../Panel';
import { AdminUserHistoryList } from './AdminUserHistoryList';
import { notify } from 'app/components/common/notify';

export const AdminBnrDiffMulitDetail = observer(() => {
	const { adminBnrDiffUiStore, uiStore } = useStore();
	const bnrDiff = adminBnrDiffUiStore.currentMulti;
	const history = useHistory();

	const onClose = () => {
		runInAction(() => {
			adminBnrDiffUiStore.currentMulti = undefined;
			history.push(routes.ADMINBNRDIFFMULTI.getPath());
		});
	};

	const onAssignToExistingUser = () => {
		uiStore.showModal(uiStore.modalIds.assignBnrIdToExistingUser);
	};

	return (
		<>
			{bnrDiff && (
				<Panel title={bnrDiff.diff.bnrId?.toString() ?? ''} subtitle={''} header={<> </>} onClose={onClose}>
					<table className="table">
						<tbody>
							<tr>
								<td>Status</td>
								<td className="full-width">
									<strong>{bnrDiff.diff.stat}</strong>
									{bnrDiff.diff.stat === 'noaccount' && (
										<>
											<br />
											<br />
											<Button onClick={onAssignToExistingUser}>BnrId einem existierenden Benutzerkonto zuordnen</Button>{' '}

										</>
									)}
								</td>
							</tr>
							<tr>
								<td>Name</td>
								<td className="full-width">{bnrDiff.diff.name}</td>
							</tr>
							{bnrDiff.user && (
								<tr>
									<td>Benutzer</td>
									<td className="full-width">
										Created: Date: {formatDateLong(bnrDiff.user.user.created)}
										<br />
										{bnrDiff.user.user.email} {bnrDiff.user.user.bensl} [{bnrDiff.user.user.steartText}]<br />
										Status: {bnrDiff.user.user.statusText}
										<br />
										AnzahlAgts: {bnrDiff.user.user.agtCount}
										<br />
										<br />
										<pre>{bnrDiff.user.user.comment}</pre>
									</td>
								</tr>
							)}
							{bnrDiff.user && bnrDiff.user.user.history.length > 0 && (
								<tr>
									<td>Historie</td>
									<td className="full-width">
										<AdminUserHistoryList user={bnrDiff.user.user} />
									</td>
								</tr>
							)}
						</tbody>
					</table>
					<AssignBnrIdToExistingUserModal diff={bnrDiff} onClose={() => uiStore.hideModal(uiStore.modalIds.assignBnrIdToExistingUser)} />
				</Panel>
			)}
		</>
	);
});

interface IAssignBnrIdToExistingUserModalProps {
	diff: BnrMulitDiffVM;
	onClose: () => void;
}

const AssignBnrIdToExistingUserModal = observer((props: IAssignBnrIdToExistingUserModalProps) => {
	const { uiStore, adminUserUiStore, adminBnrDiffUiStore } = useStore();

	const [existingBnrId, setExistingBnrId] = useState<string>('');
	const [transferData, setTransferData] = useState<boolean>(true);
	const [matchedUser, setMatchedUser] = useState<UserVM | undefined>(undefined);

	useEffect(() => {
		adminUserUiStore.findAll();
	}, [adminUserUiStore]);

	useEffect(() => {
		const n = parseInt(existingBnrId);
		if (!n) {
			setMatchedUser(undefined);
			return;
		}
		const user = adminUserUiStore._items.find((u) => u.user.bnrId === n && u.user.status === UserStatus.active);
		setMatchedUser(user);
	}, [existingBnrId, adminUserUiStore, adminUserUiStore._items]);

	const onBnrIdChange = (_name: string, value: string) => {
		setExistingBnrId(value);
	};

	const onTransferToggle = (_name: string, value: boolean) => {
		setTransferData(value);
	};

	const onAssign = () => {
		if (!matchedUser || !props.diff.diff.bnrId) {
			return;
		}
		const req = {
			oldBnrId: matchedUser.user.bnrId,
			newBnrId: props.diff.diff.bnrId,
			moveData: transferData, // move vs transfer <-> same person vs different person
			transferData: false
		};
		if (!window.confirm("Sind Sie sicher? Dies kann nicht rückgängig gemacht werden!!")) {
			return;
		}
		adminUserUiStore.updateUserBnrId(req).then(() => {
			adminBnrDiffUiStore.checkKwsAndLoad().then(() => {
				notify('BnrId Umzug', 'Multisagentur Job gestartet und OrgaInfoUpdate mit Multis-Bezug ausgeführt.');
				props.onClose();
			});
		});
	};

	return (
		<Modal modalId={uiStore.modalIds.assignBnrIdToExistingUser} title={'BnrId einem existierenden Benutzerkonto zuordnen'} onClose={props.onClose}>
			<>
				Neue BnrId: <strong>{props.diff.diff.bnrId}</strong>
				<br />
				<br />
				<InputControl
					inline={true}
					label="BnrId des existierenden Benutzers"
					name="existingBnrId"
					value={existingBnrId}
					onChange={onBnrIdChange}
					placeholder={'BnrId eingeben'}
				/>
				{existingBnrId && !matchedUser && <div>Kein aktiver Benutzer mit dieser BnrId gefunden.</div>}
				{matchedUser && (
					<div>
						Gefunden: {matchedUser.user.name} [{matchedUser.user.bensl}] {matchedUser.user.email} ({matchedUser.user.steartText})
					</div>
				)}
				<br />
				<CheckboxControl label="Bestehende Dokumente etc. auf neue BnrId verschieben" name="transferData" value={transferData} onChange={onTransferToggle} />
				<br />
				<Button onClick={props.onClose}>Cancel</Button>{' '}
				<Button onClick={onAssign} disabled={!matchedUser}>
					Zuordnen
				</Button>
			</>
		</Modal>
	);
});
